module.exports = __webpack_public_path__ + "img/5.bd4912c0.jpg";